export const ACCREDITED_MAP = [
  'skip',
  'Net Worth',
  'Individual Income',
  'Joint Income',
  'Entity Accredited Investor',
  'Qualified Purchaser',
  'Qualified Institutional Buyer',
  false,
  'Professional Designation',
];

export const SIGNUP_STEP_MAP = [
  'create your account',
  'financial situation',
  'invested in farmland',
  'complete your account',
];

export const SIGNUP_SOCIAL_STEP_MAP = [
  'create your account',
  'complete your account',
  'financial situation',
  'invested in farmland',
];

export const FINANCIAL_SITUATION = [
  'Net Worth',
  'Individual Income',
  'Joint Income',
  'Entity Accredited Investor',
  'Qualified Purchaser',
  'Qualified Institutional Buyer',
  'None of these apply to me',
  'Professional Designation',
];
